import { Table, Heading } from '@zillow/constellation';
import React from 'react';
import { IEscrowWireDisbursementsData } from 'types/order/escrow/IEscrowWireDisbursementsData';
import { WireDisbursementRow } from './WireDisbursementRow';
import { useGetPaymentsData } from '../../hooks/useGetPaymentsData';

export interface IEscrowWireDisbursementsContainerProps {
  wireDisbursements: IEscrowWireDisbursementsData[];
}

const tableHeaders = [
  'Fee Information',
  'Beneficiary',
  'Amount',
  'Spruce Account Label',
  'Spruce Account',
  'Spruce Bank',
  'Receiving Party Account',
  'Receiving Party Routing',
  'Memo',
  'Category',
  'Wells Fargo Transaction Number',
  'Federal Reference #',
  'Sent At',
  'Disbursed At',
  'Completed At',
  'Voided At',
];

export const EscrowWireDisbursementsContainer: React.FC<IEscrowWireDisbursementsContainerProps> = ({
  wireDisbursements,
}) => {
  const data = useGetPaymentsData(wireDisbursements);

  return (
    <>
      <Heading level={1}>Wire Disbursements</Heading>
      <Table aria-label="Wire Disbursements" size={'sm'} appearance={'zebra'}>
        <Table.Header appearance={'dark'}>
          <Table.Row>
            {tableHeaders.map((header) => (
              <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((item) => (
            <WireDisbursementRow key={item.id} item={item} />
          ))}
        </Table.Body>
      </Table>
    </>
  );
};
